module.exports = __webpack_public_path__ + "img/1175.25bc7937.gif";